// import node module libraries
import FooterWithLinks from "layouts/marketing/footers/FooterWithLinks";
import NavbarLanding from "layouts/marketing/navbars/NavbarLanding";
import { Fragment, useEffect } from "react";

// import sub components
import { Container } from "react-bootstrap";
import AcademyStats from "./AcademyStats";
import CTA from "./CTA";
import Features2Columns from "./Features2Columns";
import HeroAcademy from "./HeroAcademy";
import Pronostico from "./Pronostico";
import Rivales from "./Rivales";
import StationPlans from "./StationPlans";
// import SimplePricingPlans from "./SimplePricingPlans";
// import MostPopularCourses from "./MostPopularCourses";
// import WhatCustomersSay from "./WhatCustomersSay";

const HomeAcademy = () => {
  useEffect(() => {
    window.location.replace("https://gasinador.com");
  }, []);

  return (
    <Fragment>
      <NavbarLanding />
      {/* Hero Academy banner section */}
      <HeroAcademy />

      {/* Various acedamy statistics  */}
      <AcademyStats />

      {/* Most Popular Courses */}
      {/* <MostPopularCourses /> */}

      <section className="pb-8 pb-lg-12 bg-white">
        <Container>
          <Rivales />
          <br />
          <br />
          <Pronostico />
        </Container>
      </section>

      <Features2Columns />

      {/* What our customers say */}
      {/* <WhatCustomersSay /> */}
      {/* <section className="pt-lg-16 pb-lg-14 pt-8 pb-8">
        <Container>
          <SimplePricingPlans />
        </Container>
      </section> */}
      <StationPlans />
      {/* Become an instructor */}
      <CTA />
      <FooterWithLinks />
    </Fragment>
  );
};
export default HomeAcademy;
